import React from 'react'

export default function () {
  return (
    <div>
      <h1>Contact Us</h1>
    </div>
  )
}
